import { render, staticRenderFns } from "./SrProjectList.vue?vue&type=template&id=25b40bae&"
import script from "./SrProjectList.vue?vue&type=script&lang=js&"
export * from "./SrProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports